import { render, staticRenderFns } from "./ReadonlyRenderizacaoFormularioDinamicoComponent.vue?vue&type=template&id=6f4e82fc&scoped=true"
import script from "./ReadonlyRenderizacaoFormularioDinamicoComponent.vue?vue&type=script&lang=js"
export * from "./ReadonlyRenderizacaoFormularioDinamicoComponent.vue?vue&type=script&lang=js"
import style0 from "./ReadonlyRenderizacaoFormularioDinamicoComponent.vue?vue&type=style&index=0&id=6f4e82fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e82fc",
  null
  
)

export default component.exports